import React, { useState, useEffect, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";

import MDBox from "components/MDBox";
import MDButton from "components/MDButton";
import Icon from "@mui/material/Icon";

import MDActionConfigurator from "components/MDActionConfigurator";

import {
  newTransactionCreate,
  updatingTransaction,
} from "actions/transactionActions";
import { getPaymentInfo } from "actions/infoActions";
// import { getClientList } from "actions/clientActions";

function CreateTransactionButton({ selectOrder }) {
  const configuratorRef = useRef(null);
  const dispatch = useDispatch();
  // const [selectClient, setSelectClient] = useState([]);
  const [selectTransactionMethod, setSelectTransactionMethod] = useState({});
  const [currentState, setCurrentState] = useState("");
  const [currentData, setCurrentData] = useState({
    _id: "",
    transactionCode: "",
    client: "",
    order: "",
    transactionMethod: "",
    amount: 0,
    status: "",
  });

  console.log("selected order: ", selectOrder);

  const paymentInfo = useSelector((state) => state.paymentInfo);
  const { info } = paymentInfo;

  useEffect(() => {
    // if (info) {
    dispatch(getPaymentInfo());
    // }
  }, [dispatch]);

  useEffect(() => {
    let selectInfo = [];
    info?.map((val) => {
      selectInfo.push({ name: val?.method, value: val?.method });
    });
    console.log("🚀 ~ file: index.js:46 ~ useEffect ~ selectInfo:", selectInfo);
    setSelectTransactionMethod(selectInfo);
  }, [info?.length]);

  // const listClients = useSelector((state) => state.listClients);
  // const { clientsList } = listClients;

  // useEffect(() => {
  //   if (clientsList?.length === 0) {
  //     dispatch(getClientList());
  //   }
  //   setSelectClient(
  //     clientsList?.map((item) => ({
  //       value: item._id,
  //       name: item.name,
  //     }))
  //   );
  // }, [dispatch, clientsList?.length]);

  // const selectTransactionMethod = [
  //   {
  //     name: "MPESA",
  //     value: "MPESA",
  //   },
  // ];

  const handleToggleBackdrop = (item, state) => {
    setCurrentData(item);
    setCurrentState(state);
    if (configuratorRef.current) {
      configuratorRef.current.handleToggleConfigurator();
    }
  };

  const handleSubmitTransaction = (e) => {
    if (currentState === "edit") {
      console.log("transaction updating", e);
      dispatch(updatingTransaction(currentData?._id, e));
    } else {
      console.log("transaction creating", e);
      dispatch(newTransactionCreate(e));
    }
    handleToggleBackdrop({}, "");
  };

  return (
    <MDBox display="flex" alignItems="center" lineHeight={0}>
      <MDBox mt="auto">
        <MDButton
          component="a"
          href="#"
          rel="noreferrer"
          variant="gradient"
          color="info"
          onClick={() =>
            handleToggleBackdrop(
              {
                _id: "",
                transactionCode: "",
                client: "",
                order: "",
                transactionMethod: "",
                amount: 0,
                status: "",
              },
              ""
            )
          }
        >
          <Icon sx={{ fontWeight: "bold" }}>add</Icon>
          &nbsp;Manual Transaction
        </MDButton>
      </MDBox>

      <MDActionConfigurator
        ref={configuratorRef}
        title="Manual Transaction Config"
        subtitle={`Transaction for ${selectOrder?.service?.service} product: ${selectOrder?.product?.productName} - ${selectOrder?.product?.productNumber} under supplier: ${selectOrder?.supplier?.supplierName}. Order: ${selectOrder?._id}`}
        onCompleteConfig={handleSubmitTransaction}
        data={[
          {
            keyType: "_id",
            valueType: currentData?._id,
          },
          {
            labelType: "Selected Order",
            placeholderType: "Selected Order",
            dataType: "disabled",
            keyType: "order",
            valueType: selectOrder?._id,
          },
          {
            labelType: "Client",
            placeholderType: "Selected Client",
            dataType: "disabled",
            keyType: "client",
            valueType: selectOrder?.requestedBy?._id,
          },
          {
            labelType: "Transaction Method",
            placeholderType: "Select Transaction Method",
            dataType: "select",
            keyType: "transactionMethod",
            valueType: currentData?.transactionMethod,
            options: selectTransactionMethod,
          },
          {
            labelType: "Transaction Code",
            placeholderType: "Enter Transaction Code",
            dataType: "text",
            keyType: "transactionCode",
            valueType: currentData?.transactionCode,
          },
          {
            labelType: "Transaction Amount",
            placeholderType: "Enter Transaction Amount",
            dataType: "number",
            keyType: "amount",
            valueType:
              parseInt(selectOrder?.computedAmount) -
              parseInt(selectOrder?.totalAmountPaid),
          },
        ]}
        state={currentState}
      />
    </MDBox>
  );
}

export default CreateTransactionButton;
